import React from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

// スタイルインポート
import "../../pages/css/works.scss";
import "../../responsive/WorksResponsive.scss";
import "../../common.scss";

// 縦線
import line from "../../img/services/Rectangle.svg";

// 制作事例01
import work01 from "../../img/works/gu-global.png";
import work02 from "../../img/works/hanasaku.png";

function PortfolioList() {
  return (
    <>
      <section className="wrk-main-sec">
        <div className="wrk-ttl">【WEB企画、WEB施策、マーケテイング】</div>
        <div className="wrk-desc">
        「集客施策」「サイト構造構築」「SEO対策」を主に担当しております。
          <br />
        ユーザーに見つけてもらい、ゴールとなるアクション（お問い合わせや購入）へと導く一連のプロセスを設計する業務となります。
        </div>
        <table border="1" class="wrk-table">
          <tr>
            <th>人数</th>
            <th>１名</th>
          </tr>
        </table>
      </section>
      <section className="wrk-main-sec">
        <div className="wrk-ttl">【WEBコーダー】</div>
        <div className="wrk-desc">
          Webサイト構築が担当業務となります。
          <br />
          主にHTML（PUG）、CSS（SASS）、JAVASCRIPT（REACT）の言語を使用してコーディングしています。
        </div>
        <table border="1" class="wrk-table">
          <tr>
            <th>人数</th>
            <th>2名</th>
          </tr>
        </table>
      </section>
      <section className="wrk-main-sec">
        <div className="wrk-ttl">【WEBデザイナー】</div>
        <div className="wrk-desc">
          企画で決めた構造を設計書へ落とし込み、ＵＩ・ＵＸを意識しながらＷＥＢデザインをしています。
          <br />
          Adobe　Photoshop、Adobe Illustrator、Adobe XDを使用しております。
        </div>
        <table border="1" class="wrk-table">
          <tr>
            <th>人数</th>
            <th>１名</th>
          </tr>
        </table>
      </section>
      <section className="wrk-main-sec">
        <div className="wrk-ttl">【SNS運用】</div>
        <div className="wrk-desc">
          市場調査、顧客調査、認知度調査を実施し、「現状分析」を徹底して行ったうえで「今後の設計」を構築していく業務が主な担当です。
          <br />
          自社や競合のポジションの分析・把握を行うことで「認知拡大」や「売上アップ」などのお客様のフェーズにおける設計をご提案しています。
        </div>
        <table border="1" class="wrk-table">
          <tr>
            <th>人数</th>
            <th>１名</th>
          </tr>
        </table>
      </section>
      <section className="wrk-main-sec">
        <div className="wrk-ttl">【英語翻訳】</div>
        <div className="wrk-desc">
          日本語で作成したコンテンツを英語へ翻訳する業務となります。
        </div>
        <table border="1" class="wrk-table">
          <tr>
            <th>人数</th>
            <th>2名</th>
          </tr>
        </table>
      </section>

    </>
  );
}
export default PortfolioList;
